import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';

import routes from './routes';
import store from './store';

import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import TagManager from 'react-gtm-module';

const tagManagerArgs = {
    gtmId: 'GTM-KLD6RVL'
};

TagManager.initialize(tagManagerArgs);

ReactDOM.render(
    <Provider store={store}>
        <Router history={browserHistory} routes={routes} />
    </Provider>,
    document.getElementById('root')
);


// WEBPACK FOOTER //
// ./src/index.js